export function advancedMacros() {
	// noop intentionally blank. All plugin files are loaded via WRM
}

export function advancedMacrosWRM() {
	return [
		'wr!confluence.macros.advanced:editor_includemacro-conf-frontend',
		'wr!confluence.macros.advanced:jiraroadmap-editor',
		'wr!confluence.macros.advanced:jiraroadmap-preview',
		'wr!confluence.macros.advanced:portfolioforjiraplan-editor',
	];
}
